/* eslint-disable */
if (process.env.NODE_ENV === 'test') {
  require = require('src/utils/jestWebpackPolyfill').default;
}
/* eslint-enable */

const ftrRequire = require.context('.', false, /^\.\/(?!.*\.spec\.js$).*\.js$/);
const regName = /^\.\/(.*)\.js$/;
const filters = {};

ftrRequire.keys().map((path) => {
  const filter = ftrRequire(path).default;
  const name = path.replace(regName, '$1');
  filters[name] = filter;
  return filters;
});

delete filters.index;
export default filters;
